import { Tabs } from 'antd';
import * as React from 'react';
import MobileBreadCrumb from '../MobileBreadCrumb/MobileBreadCrumb';
import LeftDashboard from './LeftDashboard/LeftDashboard';
import './MobileDashboardDetail.scss';
import RightDashboard from './RightDashboard/RightDashboard';

const { TabPane } = Tabs;

const MobileDashboardDetail = (props) => {
  function callback(key) {}

  return (
    <div className='mobile-dashboard-detail'>
      <MobileBreadCrumb />
      <div className='title-detail'>Thu Nhập</div>
      <Tabs defaultActiveKey='1' onChange={callback} centered size='large'>
        <TabPane tab='Chi tiết thu nhập' key='1'>
          <LeftDashboard />
        </TabPane>
        <TabPane tab='Lịch sử thu nhập theo tháng' key='2'>
          <RightDashboard />
        </TabPane>
      </Tabs>
    </div>
  );
};

export default MobileDashboardDetail;
